<template>
  <div>
    <!--<p class="fixed bottom-0 text-sm" style="z-index:100">{{ contentAppGuid }} : {{ questionGuid }}</p>-->
    <div class="w-full fixed top-0 bg-white z-50 test-menu">
      <div v-if="!isOffice()" class="flex flex-wrap justify-center text-lg mt-2">
        <div class="flex items-center p-4">
          <div>
            <button
              @click="setIsOffline(false)"
              class="hover:bg-blue text-white font-bold py-1 px-3 rounded ml-4 focus:outline-none"
              :class="[!isOffline ? 'bg-blue' : 'bg-gray-300']"
            >
              Online
            </button>
            <button
              @click="setIsOffline(true)"
              class="hover:bg-blue text-white font-bold py-1 px-3 rounded ml-2 focus:outline-none"
              :class="[isOffline ? 'bg-blue' : 'bg-gray-300']"
            >
              Offline
            </button>
          </div>
        </div>
        <div class="flex items-center p-4">
          <div>
            <button
              @click="handleChangeQuestion(30, nbAnswers)"
              class="hover:bg-blue text-white font-bold py-1 px-3 rounded ml-4 focus:outline-none"
              :class="[question && question.max_chars === 30 ? 'bg-blue' : 'bg-gray-300']"
            >
              30
            </button>
            <button
              @click="handleChangeQuestion(120, nbAnswers)"
              class="hover:bg-blue text-white font-bold py-1 px-3 rounded ml-2 focus:outline-none"
              :class="[question && question.max_chars === 120 ? 'bg-blue' : 'bg-gray-300']"
            >
              120
            </button>
            <button
              @click="handleChangeQuestion(240, nbAnswers)"
              class="hover:bg-blue text-white font-bold py-1 px-3 rounded ml-2 focus:outline-none"
              :class="[question && question.max_chars === 240 ? 'bg-blue' : 'bg-gray-300']"
            >
              240
            </button>
          </div>
        </div>
        <div class="flex items-center p-4">
          <div>
            <!--<button
              @click="reset()"
              class="bg-gray-300 hover:bg-blue text-white font-bold py-1 px-3 rounded ml-4 focus:outline-none"
            >
              RESET
            </button>-->
            <button
              @click="clearStorage()"
              class="bg-gray-300 hover:bg-blue text-white font-bold py-1 px-3 rounded ml-4 focus:outline-none"
            >
              CLEAR STORAGE
            </button>
            <button
              @click="handleChangeQuestion()"
              class="hover:bg-blue text-white font-bold py-1 px-3 rounded ml-4 focus:outline-none"
              :class="[nbAnswers === 0 ? 'bg-blue' : 'bg-gray-300']"
            >
              NEW
            </button>
            <!--<button
              @click="handleChangeQuestion(0, 'DEBUG')"
              class="hover:bg-blue text-white font-bold py-1 px-3 rounded ml-4 focus:outline-none"
            >
              DEBUG
            </button>-->
            <button
              @click="handleChangeQuestion(question.max_chars, 17)"
              class="hover:bg-blue text-white font-bold py-1 px-3 rounded ml-4 focus:outline-none"
              :class="[nbAnswers === 17 ? 'bg-blue' : 'bg-gray-300']"
            >
              17
            </button>
            <button
              @click="handleChangeQuestion(question.max_chars, 100)"
              class="hover:bg-blue text-white font-bold py-1 px-3 rounded ml-2 focus:outline-none"
              :class="[nbAnswers === 100 ? 'bg-blue' : 'bg-gray-300']"
            >
              100
            </button>
            <button
              @click="handleChangeQuestion(question.max_chars, 150)"
              class="hover:bg-blue text-white font-bold py-1 px-3 rounded ml-2 focus:outline-none"
              :class="[nbAnswers === 150 ? 'bg-blue' : 'bg-gray-300']"
            >
              150
            </button>
            <button
              @click="handleChangeQuestion(question.max_chars, 200)"
              class="hover:bg-blue text-white font-bold py-1 px-3 rounded ml-2 focus:outline-none"
              :class="[nbAnswers === 200 ? 'bg-blue' : 'bg-gray-300']"
            >
              200
            </button>
            <button
              @click="handleChangeQuestion(question.max_chars, 250)"
              class="hover:bg-blue text-white font-bold py-1 px-3 rounded ml-2 focus:outline-none"
              :class="[nbAnswers === 250 ? 'bg-blue' : 'bg-gray-300']"
            >
              250
            </button>
            <button
              @click="handleChangeQuestion(question.max_chars, 300)"
              class="hover:bg-blue text-white font-bold py-1 px-3 rounded ml-2 focus:outline-none"
              :class="[nbAnswers === 300 ? 'bg-blue' : 'bg-gray-300']"
            >
              300
            </button>
            <button
              @click="handleChangeQuestion(question.max_chars, 500)"
              class="hover:bg-blue text-white font-bold py-1 px-3 rounded ml-2 focus:outline-none"
              :class="[nbAnswers === 500 ? 'bg-blue' : 'bg-gray-300']"
            >
              500
            </button>
            <button
              @click="handleChangeQuestion(question.max_chars, 1000)"
              class="hover:bg-blue text-white font-bold py-1 px-3 rounded ml-2 focus:outline-none"
              :class="[nbAnswers === 1000 ? 'bg-blue' : 'bg-gray-300']"
            >
              1000
            </button>
          </div>
        </div>
      </div>

      <GridMenu
        class="mx-auto grid-menu bg-white select-none"
        style="min-width: 1280px;"
        :style="'width:' + gridWidth + 'px;z-index:100000'"
        :itemsCount="answersCount"
        :charsMax="question.max_chars"
        :canLike="question.can_like"
        :orderedBy="orderedBy"
        :selected="selected"
        :gridMode="gridMode"
        :realItemsPerLine="realItemsPerLine"
        :itemSizeWithMargins="itemSizeWithMargins"
        :labelColumnWidth="labelColumnWidth"
        @resizeLabels="handleResize"
      />
    </div>

    <div class="min-h-screen" :class="[isOffice() ? 'pt-20' : 'pt-40']" id="content">
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        :is-full-page="true"
        loader="bars"
        background-color="#fff"
        color="#03C2EB"
      >
      </loading>

      <!-- Mode Label -->
      <div
        v-if="selectedLabels.length"
        class="mx-auto text-3xl select-none flex"
        :style="'width:' + gridWidth + 'px; height:' + gridHeight + 'px'"
      >
        <div
          v-for="(label, labelCount) in labels.filter((label) => selectedLabels.includes(label.guid_text))"
          :key="label.guid_text"
          class="flex items-start relative overflow-scroll"
        >
          <div class="flex items-start min-h-full" :style="'width:' + labelColumnWidth + 'px;'">
            <transition-group
              tag="div"
              name="sortableCards"
              class="relative flex flex-wrap sortable-animation outline-none w-full"
              :style="'min-height:' + itemSizeWithMargins.height + 'px'"
              ref="draggable"
              :id="'grid-' + selectedLabels.indexOf(label.guid_text)"
              draggable
            >
              <GridItem
                v-for="(id, order) in answersOrderByLabel[label.guid_text]"
                :key="id"
                :id="id"
                :order="answersOrder.indexOf(id)"
                :isFirst="isFirst(order, label.guid_text)"
                :containerIndex="order"
                :answer="answers[id]"
                :colors="getLabelColors(id)"
                :labelName="getLabelName(id)"
                :isSelected="answers[id].isSelected"
                :isGroupSelected="groupSelectedIndex !== null"
                :selectedCount="selected.length"
                :likesMax="likesMax"
                :charsMax="question.max_chars"
                :itemsPerLine="itemsPerLine"
                :realItemsPerLine="realItemsPerLabel[selectedLabels.indexOf(label.guid_text)]"
                :itemSizeWithMargins="itemSizeWithMargins"
                :gridMode="gridMode"
                :likesDisplay="likesDisplay"
                :connected="question.connected"
                :attendees="question.attendees"
                :idsDisplay="idsDisplay"
                @selectAnswer="selectAnswer"
                @selectGrouppedAnswers="selectGrouppedAnswers"
                :ref="'answer-' + order"
                class="grid-item outline-none"
              />
              <GridItem
                v-if="answersOrderByLabel[label.guid_text].length === 0"
                :key="'label-' + selectedLabels.indexOf(label.guid_text)"
                :charsMax="question.max_chars"
                :itemsPerLine="itemsPerLine"
                :realItemsPerLine="realItemsPerLabel[selectedLabels.indexOf(label.guid_text)]"
                :itemSizeWithMargins="itemSizeWithMargins"
                :gridMode="gridMode"
                :emptyContainer="true"
                class="grid-item outline-none container--is-empty"
              />
            </transition-group>
          </div>

          <div
            v-if="labelCount < selectedLabels.length - 1"
            class="w-4 h-full border-r border-gray-600 mr-4"
            :id="'label-column-separator-' + selectedLabels.indexOf(label.guid_text)"
          ></div>
        </div>
      </div>
      <!-- /Mode Label -->

      <div
        v-else
        class="mx-auto text-3xl select-none pt-2 overflow-scroll"
        :style="'width:' + gridWidth + 'px; height:' + gridHeight + 'px'"
        id="grid-container"
      >
        <transition-group
          tag="div"
          :name="gridMode === 'group' ? '' : 'sortableCards'"
          class="relative ml-3 flex flex-wrap sortable-animation outline-none"
          ref="draggable"
          id="grid"
          draggable
        >
          <GridItem
            v-for="(id, order) in answersOrder"
            :key="id"
            :id="id"
            :order="order"
            :isFirst="isFirst(order)"
            :containerIndex="order"
            :answer="answers[id]"
            :answerPosition="answersPosition[id]"
            :colors="!answers[id].isEOL ? getLabelColors(id) : getColors('pastel-1')"
            :labelName="!answers[id].isEOL ? getLabelName(id) : ''"
            :isSelected="answers[id].isSelected"
            :isGroupSelected="groupSelectedIndex !== null"
            :selectedCount="selected.length"
            :likesMax="likesMax"
            :charsMax="question.max_chars"
            :itemsPerLine="itemsPerLine"
            :realItemsPerLine="realItemsPerLine"
            :itemSizeWithMargins="itemSizeWithMargins"
            :gridMode="gridMode"
            :likesDisplay="likesDisplay"
            :connected="question.connected"
            :attendees="question.attendees"
            :idsDisplay="idsDisplay"
            @selectAnswer="selectAnswer"
            @selectGrouppedAnswers="selectGrouppedAnswers"
            :ref="'answer-' + order"
            class="grid-item outline-none"
          />
        </transition-group>
      </div>
    </div>
  </div>
</template>
<script>
import Loading from "vue-loading-overlay"
import { mapState, mapActions, mapMutations, mapGetters } from "vuex"
import GridItem from "./GridItem.vue"
import GridMenu from "./GridMenu.vue"
import { Draggable, Sortable } from "@shopify/draggable/lib/es5/draggable.bundle.legacy"
import { SmartQDraggableGrid, SmartQDraggableFree } from "../plugins/SmartQDraggable"

export default {
  components: {
    GridItem,
    GridMenu,
    Loading,
  },
  data() {
    return {
      draggable: null,
      smartQDraggable: null,
      gridWidth: 0,
      gridHeight: 0,
      labelColumnSeparatorWidth: 32,
      labelColumnWidth: 0,
      lowestItem: {
        top: 0,
        left: 0,
      },
      answersPosition: [],
      isLoading: false,
      questionGuids: {
        "0-DEBUG": "DF872C47-FCDA-432B-999B-FA8976792B72",
        "30-17": "93900E9D-4985-4AC2-8285-792F8CA7437A",
        "120-17": "AFEA0BF1-7260-4373-B6F4-FB73D05413A9",
        "240-17": "C250AFF4-7617-4583-A7A6-DA2C65BDBEC1",
        "30-100": "9FF403C5-E5CE-30B9-8072-965B03049F4D",
        "120-100": "424B3084-A79D-352F-BDF8-9A57F6171B93",
        "240-100": "E0FC0840-0427-392E-95E5-22103EA9E198",
        "30-150": "C8CD1798-703D-302E-87F4-EE65D42DF738",
        "120-150": "40CFD370-0115-3296-BB07-AB1497A37CC1",
        "240-150": "F482581A-2EBE-3CA8-82CD-EA318D864DFE",
        "30-200": "9C166DC8-9599-3A9C-92B6-CEDCF386C1C6",
        "120-200": "E355CC47-E391-3B61-BC25-FFD07182A814",
        "240-200": "B05BBD50-02D1-3B77-9E49-45EC76B1BB3B",
        "30-250": "30CD3B0C-F95E-303E-9EEF-D06BADA63418",
        "120-250": "87B46D60-A0BC-33BB-9D00-BD91BEB5DFEA",
        "240-250": "48AC5EA0-3622-3BC3-8FA9-355104D4C120",
        "30-300": "1F74088D-2046-32FB-8D1C-D6C416168293",
        "120-300": "F2BDE43B-8181-326F-AFAA-957EBEB0CF25",
        "240-300": "6E23F553-7E1F-31C9-9FAE-F11C85ADFD4C",
        "30-500": "1E9E2483-8824-3A5C-BF8D-35FF17869BF3",
        "120-500": "EEB0ED1A-1668-3D51-AB04-7A8D4557C880",
        "240-500": "5684B0E3-3036-3B07-BC3D-5AA450A61D8E",
        "30-1000": "E2E9D562-83E9-3C40-A66C-53DF70D51FFA",
        "120-1000": "6226A6F8-6544-30A6-B73E-33850684D1DF",
        "240-1000": "536048AE-C32F-3AF5-A7E2-DA1DBC0F9556",
      },
      userAgent: navigator.userAgent,
    }
  },
  computed: {
    ...mapGetters("answers", ["getLabelName", "isFirst", "getLabelColors"]),
    ...mapGetters("labels", ["getColors"]),
    ...mapState({
      isOffline: (state) => state.app.isOffline,
      contentAppGuid: (state) => state.app.contentApp.guid,
      question: (state) => state.question,
      questionGuid: (state) => state.question.guid_text,
      answers: (state) => state.answers.all,
      answersOrder: (state) => state.answers.order,
      answersOrderByLabel: (state) => state.answers.orderByLabel,
      answersCount: (state) => state.answers.answersCount,
      likesMax: (state) => state.question.likes_max,
      groups: (state) => state.answers.groups,
      groupSelectedIndex: (state) => state.answers.groupSelectedIndex,
      selected: (state) => state.answers.selected,
      accessToken: (state) => state.pilot.accessToken,
      itemsPerLine: (state) => state.grid.itemsPerLine,
      realItemsPerLine: (state) => state.grid.realItemsPerLine,
      realItemsPerLabel: (state) => state.grid.realItemsPerLabel,
      itemSizeWithMargins: (state) => state.grid.itemSizeWithMargins,
      gridMode: (state) => state.grid.gridMode,
      likesDisplay: (state) => state.grid.likesDisplay,
      idsDisplay: (state) => state.grid.idsDisplay,
      orderedBy: (state) => state.grid.orderedBy,
      deselect: (state) => state.grid.deselect,
      hasLabels: (state) => state.labels.all.length > 1,
      labels: (state) => state.labels.all,
      selectedLabels: (state) => state.labels.selected,
      isActive: (state) => state.live.isActive,
    }),
    /*elements: function() {
      return this.draggable.getDraggableElementsForContainer(this.$refs.draggable.$el)
    },*/
    nbAnswers() {
      return this.answers.filter((answer) => !answer.isEOL).length
    },
  },
  methods: {
    ...mapActions({
      reset: "app/reset",
      clearStorage: "app/clearStorage",
      setQuestion: "app/setQuestion",
      setItemsPerLine: "grid/setItemsPerLine",
      unstackApiCalls: "offline/unstackApiCalls",
      launchQuestion: "live/launchQuestion",
    }),
    ...mapMutations("offline", ["setIsOffline"]),
    ...mapMutations("labels", { deselectAllLabels: "deselectAll" }),
    ...mapMutations("grid", [
      "setGridMode",
      "emptyLocalStorageOptions",
      "setRealItemsPerLine",
      "setRealItemsPerLabel",
      "resetRealItemsPerLabel",
    ]),
    ...mapMutations("answers", [
      "moveAnswer",
      "multimoveAnswers",
      "updateGroups",
      "removeGroupsTopLeft",
      "removeGroup",
      "removeAllGroups",
      "selectAnswer",
      "selectGrouppedAnswers",
      "removeSelected",
    ]),
    ...mapMutations("live", ["setInactive", "toggleIsTimerAuto", "startTimer"]),
    async handleChangeQuestion(nbChars = null, nbAnswers = null) {
      this.isLoading = true

      await this.setQuestion(
        nbChars !== null && nbAnswers !== null ? this.questionGuids[nbChars + "-" + nbAnswers] : "NEW"
      )

      if (this.selectedLabels.length > 0) {
        // set grid mode to grid will deselect all labels
        this.setGridMode("grid")
      }

      this.isLoading = false
    },
    handleClickOutside(e) {
      if (
        e.target.closest(".grid-item") === null &&
        e.target.closest(".grid-menu") === null &&
        e.target.closest(".menu") === null &&
        e.target.tagName !== "BUTTON" &&
        this.selected.length > 0
      ) {
        this.removeSelected()
      }
    },
    handleResize() {
      this.setItemsPerLine(this.itemsPerLine)
      this.setRealItemsPerLine(
        Math.min(this.itemsPerLine, Math.floor(window.innerWidth / this.itemSizeWithMargins.width))
      )
      this.resetRealItemsPerLabel()

      if (this.selectedLabels.length > 0) {
        this.labelColumnWidth =
          (this.gridWidth - this.labelColumnSeparatorWidth * (this.selectedLabels.length - 1)) /
          this.selectedLabels.length

        this.selectedLabels.map((label, labelIndex) => {
          const labelGrid = document.getElementById("grid-" + labelIndex)

          if (labelGrid !== null) {
            this.setRealItemsPerLabel(
              Math.max(1, Math.floor((labelGrid.offsetWidth - 20) / this.itemSizeWithMargins.width))
            )

            if (document.getElementById("label-column-separator-" + labelIndex)) {
              document.getElementById("label-column-separator-" + labelIndex).style.height =
                Math.max(labelGrid.offsetHeight, this.gridHeight) + "px"
            }
          }
        })
      }

      this.gridWidth = Math.min(this.realItemsPerLine, this.itemsPerLine) * this.itemSizeWithMargins.width + 12 + 25
      if (window.Office) {
        this.gridHeight = window.innerHeight - 90
      } else {
        this.gridHeight = window.innerHeight - 168
      }
    },
    createDraggable() {
      if (this.draggable) {
        this.draggable.destroy()
      }

      this.draggable = new Draggable(document.querySelectorAll("[draggable]"), {
        draggable: ".grid-item",
        delay: 200,
        plugins: [this.gridMode === "free" ? SmartQDraggableFree : SmartQDraggableGrid],
        smartq: {
          gridMode: this.gridMode,
          selected: this.selected,
          selectedLabels: this.selectedLabels,
        },
        scrollable: {
          speed: 20,
          sensitivity: 30,
        },
      })

      this.smartQDraggable = this.draggable.plugins[4]

      if (this.gridMode !== "free") {
        this.draggable.on("smartq:move", (e) => {
          this.moveAnswer(e.data)
          if (this.selectedLabels.length) {
            this.$nextTick(() => {
              this.handleResize()
            })
          }
        })
        this.draggable.on("smartq:mutlimove", (e) => {
          this.multimoveAnswers(e.data)
          if (this.selectedLabels.length) {
            this.$nextTick(() => {
              this.handleResize()
            })
          }
        })
      } else {
        this.draggable.on("smartq:group", (e) => {
          this.updateGroups(e.data)
        })
        this.draggable.on("smartq:freemove", (e) => {
          e.data.map((topItem) => {
            this.answersPosition[this.answersOrder[topItem.index]].top = topItem.top
            this.answersPosition[this.answersOrder[topItem.index]].left = topItem.left
          })

          let lowestPosition = {}
          lowestPosition.top = this.answersPosition.reduce((a, b) => (a.top > b.top ? a : b)).top
          lowestPosition.left = this.answersPosition
            .filter((answer) => answer.top > lowestPosition.top - this.itemSizeWithMargins.height)
            .reduce((a, b) => (a.left > b.left ? a : b)).left

          this.lowestItem.top = lowestPosition.top
          this.lowestItem.left = lowestPosition.left + this.itemSizeWithMargins.width
        })
      }

      this.draggable.on("drag:stop", () => {
        if (this.deselect && this.selected.length > 0) {
          this.removeSelected()
        }
      })
    },
    isOffice() {
      return window.Office !== undefined
    },
  },
  watch: {
    selectedLabels() {
      if (this.selectedLabels.length > 0) {
        if (this.gridMode !== "label") {
          this.setGridMode("label")
        }
        this.$nextTick(() => {
          this.createDraggable()
          this.handleResize()
          this.$forceUpdate()
        })
      } else {
        this.$nextTick(() => {
          this.createDraggable()
        })
      }
    },
    answers(newAnswers, oldAnswers) {
      this.isLoading = false

      if (this.gridMode === "free") {
        // case new question or question changed
        if (
          oldAnswers.length === 0 ||
          this.answersPosition.length === 0 ||
          (newAnswers.length > 0 && oldAnswers[0].question_guid_text !== newAnswers[0].question_guid_text)
        ) {
          this.answersPosition = []
          for (let i = 0; i < this.answersCount; i++) {
            this.answersPosition.push({
              top: 0,
              left: 0,
            })
          }
          this.lowestItem = {
            top: 0,
            left: 0,
          }
          this.answersOrder.map((id) => {
            this.answersPosition[id].top = this.lowestItem.top =
              this.lowestItem.top +
              (this.lowestItem.left + this.itemSizeWithMargins.width > this.gridWidth
                ? this.itemSizeWithMargins.height
                : 0)
            this.answersPosition[id].left =
              this.lowestItem.left + this.itemSizeWithMargins.width > this.gridWidth ? 0 : this.lowestItem.left
            this.lowestItem.left = this.answersPosition[id].left + this.itemSizeWithMargins.width
          })
        } else if (newAnswers.length === this.answersPosition.length + 1) {
          this.answersPosition.push({
            top: 0,
            left: 0,
          })
          this.lowestItem.top = this.answersPosition[this.answersCount - 1].top =
            this.lowestItem.top +
            (this.lowestItem.left + this.itemSizeWithMargins.width > this.gridWidth
              ? this.itemSizeWithMargins.height
              : 0)
          this.answersPosition[this.answersCount - 1].left =
            this.lowestItem.left + this.itemSizeWithMargins.width > this.gridWidth ? 0 : this.lowestItem.left
          this.lowestItem.left = this.answersPosition[this.answersCount - 1].left + this.itemSizeWithMargins.width
        }
      }
    },
    itemsPerLine() {
      this.handleResize()
    },
    "question.max_chars"() {
      this.handleResize()
    },
    gridMode() {
      if (this.gridMode !== "label") {
        this.createDraggable()
      }
      if (this.gridMode === "free" || this.gridMode === "grid") {
        // remove free groups
        this.removeAllGroups()
      }
      if (this.selected.lenght > 0) {
        this.removeSelected()
      }
      this.answers.map((answer, index) => {
        if (this.$refs["answer-" + index] && this.$refs["answer-" + index].length) {
          this.$refs["answer-" + index][0].$el.classList.remove("bloc--is-superimposed")
          this.$refs["answer-" + index][0].$el.classList.remove("bloc--is-groupped")
          if (this.$refs["answer-" + index][0].$el.firstChildElement) {
            this.$refs["answer-" + index][0].$el.firstChildElement.firstChildElement.classList.remove(
              "bloc-group-icon--is-visible"
            )
          }
        }
      })
    },
    groups() {
      // free grid mode
      if (this.smartQDraggable) {
        // transform id to order
        let groupsWithOrder = []
        this.groups.map((group, groupIndex) => {
          groupsWithOrder.push([])
          group.map((id) => {
            groupsWithOrder[groupIndex].push(this.answersOrder.indexOf(id))
          })
        })
        this.smartQDraggable.options.groups = groupsWithOrder
      }
    },
    groupSelectedIndex() {
      this.smartQDraggable.options.groupSelectedIndex = this.groupSelectedIndex
    },
    selected() {
      this.smartQDraggable.options.selected = this.selected
    },
    /*isOffline(newValue, oldValue) {
      if (oldValue === true && newValue === false) {
        this.unstackApiCalls()
      }
    },*/
  },
  created() {
    this.isLoading = true

    window.addEventListener("resize", this.handleResize)
    window.addEventListener("click", this.handleClickOutside)

    this.isLoading = false
  },
  mounted() {
    this.handleResize()
    this.createDraggable()
  },
  destroyed() {
    if (this.draggable) {
      this.draggable.destroy()
    }
    window.removeEventListener("resize", this.handleResize)
    window.removeEventListener("click", this.handleClickOutside)
  },
}
</script>
<style>
@import "~vue-loading-overlay/dist/vue-loading.css";
/* put the vld styles def to avoid webpack removing them because unused
improve: add webpack rules to manage that
.vld-overlay {}
.vld-overlay.is-active {}
.vld-overlay.is-full-page {}
.vld-overlay .vld-background {}
.vld-overlay .vld-icon, .vld-parent {} */

.sortable-animation > * {
  transform: translate3d(0, 0, 0);
}
.sortableCards-move {
  transition: transform cubic-bezier(0.22, 0.61, 0.36, 1) 500ms;
}
/*.sortableCards-enter,
.sortableCards-leave-to {
  transition: 1s;
  opacity: 0;
}*/
.draggable-mirror {
  border: 0 none !important;
}
.draggable-source--is-dragging {
  opacity: 0.3;
  scale: 0.8;
}
/* Hide scrollbar for Chrome, Safari and Opera */
.overflow-scroll::-webkit-scrollbar {
  display: none;
}

/* Hide scrollbar for IE and Edge */
.overflow-scroll {
  -ms-overflow-style: none;
}
</style>
